import React, { useRef, useEffect, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Header from "../../components/common/Header";
import ContactFormSection from "./ContactFormSection";

// GSAP plugins रजिस्टर करें (केवल एक बार)
gsap.registerPlugin(ScrollTrigger);

const ContactHero = ({ pressReleases }) => {
  // 1. Ref बनाएं
  const sectionRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    // सुनिश्चित करें कि ref मौजूद है
    if (!sectionRef.current) return;

    // 2. GSAP context बनाएं
    const context = gsap.context(() => {
      // --- 1. Hero Title Animation (Slide-in) ---
      if (titleRef.current) {
        gsap.fromTo(
          titleRef.current,
          {
            y: 50,
            opacity: 0,
            // आपके द्वारा दिए गए 'clipPath' स्टाइल को यहाँ लागू करना
            clipPath: "inset(100% 0 0% 0)",
          },
          {
            y: 0,
            opacity: 1,
            clipPath: "inset(0% 0 0% 0)",
            duration: 1.2,
            ease: "power2.out",
            scrollTrigger: {
              trigger: sectionRef.current, // पूरे सेक्शन के दिखने पर ट्रिगर करें
              start: "top 80%", // जब सेक्शन 80% पर पहुंचे
              toggleActions: "play none none none",
            },
          },
        );
      }

      // --- 2. Press Release Cards Animation (Staggered Slide-in) ---
      // 'animated-press-card' क्लास वाले सभी कार्ड्स को target करें
      const cards = gsap.utils.toArray(
        sectionRef.current.querySelectorAll(".animated-press-card"),
      );

      gsap.from(cards, {
        y: 80, // नीचे से शुरू
        opacity: 0,
        stagger: 0.2, // कार्ड्स को बारी-बारी से एनिमेट करें
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: cards,
          start: "top 90%", // जब पहला कार्ड 90% पर पहुंचे
          toggleActions: "play none none none",
          // markers: true,
        },
      });
    }, sectionRef); // Pass the ref to the context

    // Cleanup function
    return () => context.revert();
  }, []); // Empty dependency array means this runs once
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    console.log("Form Submitted:", formData);
  };
  return (
    // sectionRef को सबसे बाहरी तत्व पर लगाएं
    <div
      ref={sectionRef}
      className="relative w-full h-full"
      style={{
        backgroundImage: "url(/assets/contect/ContactBg.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Header and Content Overlay */}
      <div className=" inset-0 flex flex-col justify-start items-center w-full h-full">
        <Header />
        {/* Header Section */}
        <div className="w-full bg-cover bg-center pb-[23px] sm:pb-[34px] lg:pb-[46px] h-full flex flex-col justify-between items-center">
          {/* Press Release Title */}
          <div className="flex justify-center mt-[80px] sm:mt-[100px] lg:mt-[135px]">
            {/* titleRef को यहां लगाएं */}
            <h1
              ref={titleRef}
              className="text-[40px] sm:text-[60px] md:text-[100px] lg:text-hero font-[Parkinsans] font-bold leading-[56px] sm:leading-[84px] md:leading-[112px] lg:leading-hero text-center text-[#343163]"
            >
              Contact Us
            </h1>
          </div>
          <div className="w-full max-w-[1620px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10 mt-[100px] sm:mt-[60px] lg:mt-[216px]">
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-[48px] justify-start items-center">
              <ContactFormSection
                formData={formData}
                handleInputChange={handleInputChange}
                handleSubmit={handleSubmit}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Overlay Gradients */}
      {/* <div className="absolute bottom-0 left-0 w-full h-[260px] sm:h-[300px] lg:h-[382px] bg-[linear-gradient(180deg,#0f100900_0%,_#0f1009_100%)]"></div> */}
      <div className=" w-full h-[160px] sm:h-[120px] lg:h-[146px] bg-[#0F1009]"></div>
    </div>
  );
};

export default ContactHero;
